import React, { useState, useEffect } from "react";
import Step0 from "../Step0/Step0";
import Step1 from "../Step1/Step1";
import Step2 from "../Step2/Step2";
import Step3 from "../Step3/Step3";
import Step4 from "../Step4/Step4";
import Step5 from "../Step5/Step5";
import Step6 from "../Step6/Step6";

const STEP_TITLES = {
  step1: "Персональные данные",
  step2: "Профессия",
  step31: "Данные для Экскурсоводов",
  step32: "Данные для Администраторов",
  finish: "Спасибо",
};

function Form() {
  const [title, setTitle] = useState("Персональные данные");

  const [step, setStep] = useState(0);

  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [patronymic, setPatronymic] = useState("");
  const [experience, setExperience] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [address, setAddress] = useState("");
  const [job, setJob] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [participantPhoto, setParticipantPhoto] = useState("");
  const [education, setEducation] = useState("");
  const [languages, setLanguages] = useState("");

  const [profession, setProfession] = useState(null);

  const [excursionTitle, setExcursionTitle] = useState("");
  const [excursionRoute, setExcursionRoute] = useState("");
  const [excursionTargets, setExcursionTargets] = useState("");
  const [excursionDuration, setExcursionDuration] = useState("");
  const [excursionLength, setExcursionLength] = useState("");
  const [shortDescription, setShortDescription] = useState("");
  const [videoDescription, setVideoDescription] = useState("");
  const [videoFragment, setVideoFragment] = useState("");

  const [adminExperience, setAdminExperience] = useState("");
  const [unionParticipation, setUnionParticipation] = useState("");
  const [pastedСourses, setPastedСourses] = useState("");
  const [selfPresentationVideo, setSelfPresentationVideo] = useState("");
  const [esse, setEsse] = useState("");

  const [agreement, setAgreement] = useState(false);
  const [dataAgreement, setDataAgreement] = useState(false);

  useEffect(() => {
    if (step === 1) {
      setTitle(STEP_TITLES.step1);
    }
    if (step === 2) {
      setTitle(STEP_TITLES.step2);
    }
    if (step === 3) {
      if (profession === 1) {
        setTitle(STEP_TITLES.step31);
      }
      if (profession === 2) {
        setTitle(STEP_TITLES.step32);
      }
    }
  }, [step, profession]);

  return (
    <div className="mm-form">
      {step !== 0 && step !== 4 && step !== 5 && step !== 6 && (
        <>
          <div className="mm-form-steps">
            <div className="mm-form-steps__item mm-form-steps__item_active"></div>
            <div
              className={
                step >= 2
                  ? "mm-form-steps__item mm-form-steps__item_active"
                  : "mm-form-steps__item"
              }
            ></div>
            <div
              className={
                step >= 3
                  ? "mm-form-steps__item mm-form-steps__item_active"
                  : "mm-form-steps__item"
              }
            ></div>
          </div>

          <div className="mm-form-header">
            <div className="mm-form-header__step">Шаг {step}</div>
            <div className="mm-form-header__title">{title}</div>

            <div
              className={`mm-form-header__count mm-form-header__count-${step}`}
            >
              <div>{step}/3</div>
            </div>
          </div>
        </>
      )}

      {(() => {
        switch (step) {
          case 1:
            return (
              <Step1
                setStep={setStep}
                name={name}
                setName={setName}
                surname={surname}
                setSurname={setSurname}
                patronymic={patronymic}
                setPatronymic={setPatronymic}
                experience={experience}
                setExperience={setExperience}
                birthDate={birthDate}
                setBirthDate={setBirthDate}
                address={address}
                setAddress={setAddress}
                job={job}
                setJob={setJob}
                email={email}
                setEmail={setEmail}
                phone={phone}
                setPhone={setPhone}
                participantPhoto={participantPhoto}
                setParticipantPhoto={setParticipantPhoto}
                education={education}
                setEducation={setEducation}
                languages={languages}
                setLanguages={setLanguages}
                dataAgreement={dataAgreement}
                setDataAgreement={setDataAgreement}
              />
            );
          case 2:
            return (
              <Step2
                setProfession={setProfession}
                profession={profession}
                setStep={setStep}
              />
            );
          case 3:
            return (
              <Step3
                name={name}
                surname={surname}
                patronymic={patronymic}
                experience={experience}
                birthDate={birthDate}
                address={address}
                job={job}
                email={email}
                phone={phone}
                participantPhoto={participantPhoto}
                education={education}
                languages={languages}
                profession={profession}
                setProfession={setProfession}
                setStep={setStep}
                excursionTitle={excursionTitle}
                setExcursionTitle={setExcursionTitle}
                excursionRoute={excursionRoute}
                setExcursionRoute={setExcursionRoute}
                excursionTargets={excursionTargets}
                setExcursionTargets={setExcursionTargets}
                excursionDuration={excursionDuration}
                setExcursionDuration={setExcursionDuration}
                excursionLength={excursionLength}
                setExcursionLength={setExcursionLength}
                shortDescription={shortDescription}
                setShortDescription={setShortDescription}
                videoDescription={videoDescription}
                setVideoDescription={setVideoDescription}
                videoFragment={videoFragment}
                setVideoFragment={setVideoFragment}
                adminExperience={adminExperience}
                setAdminExperience={setAdminExperience}
                unionParticipation={unionParticipation}
                setUnionParticipation={setUnionParticipation}
                pastedСourses={pastedСourses}
                setPastedСourses={setPastedСourses}
                selfPresentationVideo={selfPresentationVideo}
                setSelfPresentationVideo={setSelfPresentationVideo}
                esse={esse}
                setEsse={setEsse}
                agreement={agreement}
                setAgreement={setAgreement}
                dataAgreement={dataAgreement}
                setDataAgreement={setDataAgreement}
              />
            );
          case 4:
            return <Step4 />;
          case 5:
            return <Step5 />;
          case 6:
            return <Step6 />;
          default:
            return <Step0 setStep={setStep} />;
        }
      })()}
    </div>
  );
}

export default Form;
